module.exports = __webpack_public_path__ + "img/animals_05_V.6d5b13c7.webp";